import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NotificationsState {
  unreadNotificationsMessages: number;
  unreadNotificationsDocuments: number;
}

const initialState: NotificationsState = {
  unreadNotificationsMessages: 0,
  unreadNotificationsDocuments: 0,
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setUnreadNotificationsMessages: (
      state: NotificationsState,
      action: PayloadAction<number>
    ) => {
      state.unreadNotificationsMessages = action.payload;
    },
    setUnreadNotificationsDocuments: (
      state: NotificationsState,
      action: PayloadAction<number>
    ) => {
      state.unreadNotificationsDocuments = action.payload;
    },
  },
});

export const {
  setUnreadNotificationsMessages,
  setUnreadNotificationsDocuments,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
